import { useRef, useMemo } from 'react'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { FeatureDict, selectFeatureIncludes } from '@authed/selectors'
import { useCreativeClassifications } from '@global/hooks/queries/useCreativeClassifications'
import { useAppSelector } from '@redux/hooks'
import { AiClassificationField } from './schema-components/ai-classification-field'
import { List } from './schema-components/list'
import * as TemplateActions from './template.actions'
import { t } from '@lingui/core/macro'

export const Schema = () => {
  const schemaRef = useRef(null)
  const dispatch = useDispatch()
  const { template } = useSelector(state => state.Template, shallowEqual)
  const { creativeConfiguration, isCreativeClassificationEnabled = false } = template
  const { data: classifications = [] } = useCreativeClassifications()

  const [CREATIVE_CLASSIFICATION_ENABLED = false] = useAppSelector(
    selectFeatureIncludes([FeatureDict.CREATIVE_CLASSIFICATION]),
  )

  const creativeFields = useMemo(() => {
    if (!creativeConfiguration || !isCreativeClassificationEnabled) return []

    return creativeConfiguration?.map(({ categoryId, threshold }) => {
      const { categoryText } = classifications.find(c => c.id === categoryId) || {}

      return {
        id: categoryId,
        categoryText,
        threshold,
      }
    })
  }, [creativeConfiguration, classifications, isCreativeClassificationEnabled])

  const showCreativeFields =
    CREATIVE_CLASSIFICATION_ENABLED &&
    !!isCreativeClassificationEnabled &&
    creativeFields?.length > 0

  return (
    <div
      style={{
        margin: 24,
        marginTop: 0,
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100% - 48px)',
      }}
    >
      <div className="pt-4 pl-[25px]">
        <div className="grid grid-cols-[minmax(180px,_1fr)_300px_140px_1fr_100px] gap-[15px]">
          <div className="flex font-bold text-sm">{t`Field name`}</div>
          <div className="flex font-bold text-sm">{t`Field set`}</div>
          <div className="flex font-bold text-sm">{t`Field type`}</div>
          <div className="flex font-bold text-sm">{t`Options`}</div>
          <div className="flex font-bold text-sm">{t`Actions`}</div>
        </div>
      </div>
      <div style={{ flex: 1, overflow: 'scroll', padding: 2 }} ref={schemaRef}>
        <List scrollRef={schemaRef}>
          {showCreativeFields && (
            <ul style={{ display: 'flex', flexDirection: 'column', gap: 10, padding: 0 }}>
              {creativeFields?.map(field => (
                <AiClassificationField
                  key={field.id}
                  fieldName={field.categoryText}
                  fieldThreshold={field.threshold}
                  onChangeTreshold={value => {
                    dispatch(TemplateActions.setCreativeThreshold({ id: field.id, value }))
                  }}
                />
              ))}
            </ul>
          )}
        </List>
      </div>
    </div>
  )
}
